"use client";

import React from "react";
import { AnimatePresence } from "framer-motion";
import { usePathname } from "next/navigation";

export default function AnimatePresenceWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <React.Fragment key={pathname}>{children}</React.Fragment>
    </AnimatePresence>
  );
}
